import { Paper, PaperProps } from '@mui/material'
import { PropsWithChildren } from 'react'

export interface ILoinPaperProps extends PaperProps {}

const LoginPaper = ({
  children,
  sx,
  ...paperProps
}: PropsWithChildren<PaperProps>) => {
  return (
    <Paper
      {...paperProps}
      sx={[
        {
          maxWidth: 'calc(100vw - 32px)',
          boxSizing: 'border-box',
          background: '#F9F9F9',
          display: 'flex',
          px: { xs: 2, sm: '44px' },
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '32px',
          boxShadow: '-24px -24px 32px -8px #FFFFFF, 16px 16px 40px -8px #00000029',
          py: '25px'
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
      ]}
    >
      {children}
    </Paper>
  )
}

export default LoginPaper
